<template>
  <label class="products-filter-field">
    <span><b-icon icon="diagram-3"></b-icon> ساختار محصول</span>
    <select @change="variationFilter" v-model="variation" class="products-filter-input">
      <option value="">همه</option>
      <option value="0">ساده</option>
      <option value="1">متغیر (تنوع‌دار)</option>
      <option value="2">رزروی</option>
    </select>
  </label>
</template>

<script>
// product structure (products.variation). Not the same as the "نوع" (physical/digital) filter.
// stored as an array so the shared queryBuilder sends it as `variation=<value>` (and nothing for "همه").
const ALLOWED = ['0', '1', '2']

export default {
  name: "Variation",
  data() {
    return {
      variation: '',
    }
  },
  methods: {
    storeValue(value) {
      return ALLOWED.indexOf(String(value)) > -1 ? [String(value)] : []
    },
    variationFilter() {
      this.$store.commit("Product/setFilters", {key: "variation", value: this.storeValue(this.variation)});
      this.$emit('updateFilter', {variation: this.variation})
      this.$store.dispatch('Product/setDashboardProducts', 1)
    }
  },
  mounted() {
    const value = this.$route.query.variation;
    if (value != undefined && ALLOWED.indexOf(String(value)) > -1) {
      this.variation = String(value)
      this.$store.commit('Product/setFilters', {key: 'variation', value: this.storeValue(value)})
    }
  },
  destroyed() {
    this.$store.commit("Product/setFilters", {key: "variation", value: []});
  }
}
</script>